
function baseConfig(baseApi) {
    const config={
        probateAPIURL: `${baseApi}/ProbateAPI/api/1.0`,
        baseurl: baseApi,
        version: "1.0.0",
        lastAccessTime: new Date().toLocaleDateString(),
        docAssembleURL: `${baseApi}/web-da/docassemble`,
        updateProfileURL: `${baseApi}/UserProfile/EditSingPassProfile`,
        isProduction: false,
        isDevelopment: false,
        isUAT: false,
    };
    return config;
}
export default baseConfig;